import { Middleware } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createStandaloneToast, ToastPosition } from "@chakra-ui/react";
import CustomToastRender from "components/Toast/CustomToastRender";

const errorMessages: any = {
  403: "Your request has been blocked due to security restrictions.</br>Please contact support to whitelist your IP address.",
  404: "Service not found",
  500: "Internal server error",
};

const toast = createStandaloneToast();

const displayedToasts = new Set<string>();

const showToast = (status: 'success' | 'error' | 'warning' | 'info', customText?: string, options?: { duration?: number; position?: ToastPosition, allowHtml: boolean, testId?: string; }) => {
  const { duration = 9000, position = 'top-right', allowHtml } = options || {};

  if (displayedToasts.has(customText || "")) {
    return;
  }

  displayedToasts.add(customText || "");

  toast({
    position,
    duration,
    render: ({ onClose }) => (
      <CustomToastRender status={status} onClose={onClose} customText={customText} allowHtml={allowHtml} data-testid={options?.testId} />
    ),
  });

  setTimeout(() => {
    displayedToasts.delete(customText || "");
  }, duration + 1000);
};

const errorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload;

    if (error?.originalStatus) {
      showToast(
        "error",
        errorMessages[error.originalStatus] || errorMessages[403],
        {
          allowHtml: true,
        }
      );

      if (error?.originalStatus === 403) return;
    }
  }

  return next(action);
};

export default errorMiddleware;
